import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '../store'
import { SlotItemInterface, SlotListResponse } from '../../common/types/interfaces'

const initialState: { data: SlotListResponse } = {
  data: {
    data: [],
    total: 0,
  },
}

export const slotListSlice = createSlice({
  name: 'slot-list',
  initialState,
  reducers: {
    setSlotList: (state, action: PayloadAction<SlotListResponse>) => {
      state.data = { ...action.payload }
    },
    replaceSlotById: (state, action: PayloadAction<SlotItemInterface>) => {
      state.data = {
        ...state.data,
        data: [...state.data.data.filter((el) => el.id !== action.payload.id)],
      }
      state.data = { ...state.data, data: [...state.data.data, action.payload] }
    },
    removeSlotById: (state, action: PayloadAction<number>) => {
      state.data = {
        ...state.data,
        data: [...state.data.data.filter((el) => el.id !== action.payload)],
      }
    },
  },
})

export const { setSlotList } = slotListSlice.actions
export const { replaceSlotById } = slotListSlice.actions
export const { removeSlotById } = slotListSlice.actions

export const selectSlotList = (state: RootState) => state.slotList.data
export const selectSlotItem = (state: RootState, id: number) =>
  state.slotList.data.data.find((el) => el.id === id)

export default slotListSlice.reducer
